import * as Yup from 'yup';

export const schema = Yup.object().shape({
  ProfileApplicationRewardAmount: Yup.number().typeError('وارد کردن مقدار پاداش الزامی است').positive('مقدار باید مثبت باشد'),
});
